import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import useRoutes from "./routes";
import { useSoftUIController } from "context";
import { NotificationProvider } from "context/notification";
import RouteGuard from "route.guard";
import "./App.css";
import { Toaster } from "react-hot-toast";
import { useAgencyInfo } from "context/agency";
import { GooglePlaceProvider } from "context/GooglePlaceContext";
import DummyDataNotification from "components/DummyDataNotification/dummyDatanotification";

export default function App() {
  const routes = useRoutes();
  const [controller] = useSoftUIController();
  const { direction, layout } = controller;
  const { pathname } = useLocation();
  const [agency] = useAgencyInfo();

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.guard) {
        const { valid, redirect, state } = route.guard;
        return (
          <Route
            element={<RouteGuard valid={valid} redirect={redirect} state={state} />}
            key={route.key}
          >
            <Route exact path={route.route} element={route.component} />
          </Route>
        );
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <GooglePlaceProvider>
      <CssBaseline />
      <NotificationProvider>

        {layout === "vr" && <Configurator />}
        <Routes>{getRoutes(routes)}</Routes>
      </NotificationProvider>
      <Toaster position="top-center" reverseOrder={false} />
      {/* {!agency?.update_pushed && (
        <div style={{ position: "fixed", bottom: 0, right: 0, backgroundColor: "#2f84be", color: "#fff", padding: "10px", zIndex: 1000, borderTopLeftRadius: "10px" }}>
          <span>Please reinstall the app to configure new updates.</span>
        </div>
      )} */}
            </GooglePlaceProvider>

    </ThemeProvider>
  );
}
